export const RESPONSIVE_BREAKPOINTS = {
  narrow: 640,
  mobile: 768,
  compact: 960,
} as const;

export const RESPONSIVE_QUERIES = {
  narrow: `(max-width: ${RESPONSIVE_BREAKPOINTS.narrow}px)`,
  mobile: `(max-width: ${RESPONSIVE_BREAKPOINTS.mobile}px)`,
  compact: `(max-width: ${RESPONSIVE_BREAKPOINTS.compact}px)`,
} as const;

